import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

// components
import { UnauthorizedComponent } from './unauthorized.component';

// services

// modules
import { SharedModule } from '../shared/shared.module';
import { LoadingModule } from '../shared/loading/loading.module';
import { SpinnerModule } from '../shared/spinner/spinner.module';
@NgModule({
  declarations: [UnauthorizedComponent],
  imports: [RouterModule, CommonModule, SharedModule, LoadingModule, SpinnerModule],
  exports: [UnauthorizedComponent],
})
export class UnauthorizedModule {}
